export const payload = {
  receiveMutation: 'RECEIVE_SETS',
  receivingMutation: 'RECEIVING_SETS',
  receiveMetadataMutation: 'RECEIVE_SET_METADATA',
  receiveFailureMutation: 'RECEIVE_SET_FAILURE',
  savingMutation: 'SAVING_SET',
  saveFailureMutation: 'SAVING_SET_FAILURE',
  incrementMutation: 'INCREMENT_SET_COUNT',
  updatingMutation: 'UPDATING_SET',
  updateFailureMutation: 'UPDATING_SET_FAILURE',
  deleteMutation: 'DELETE_SET',
  deletingMutation: 'DELETING_SET',
  deleteFailureMutation: 'DELETING_SET_FAILURE',
  resetMetaMutation: 'RESET_SET_META',
  clearMutation: 'CLEAR_SET_STATE',
  moduleName: 'set',
  endpoint: 'sets',
  defaultModelGetter: 'getDefaultSet',
  searchableFields: ['code', 'name', 'description']
}



// WEBPACK FOOTER //
// ./src/components/RouteComponents/Sets/actionPayload.js